import React from 'react';
import './BranchesListModal.scss';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Branch from "../layouts/components/Branch";

const BranchesListModal = ({ closeModal, onClose, onOk,  branches, showAllBranch = false, history}) => {
  const openBranch = (guidCode) => {
    history.push(`/${guidCode}`);
    onOk(guidCode);
    closeModal();    
  };

  return (
    <div className='branches-list-modal-content'>
      <div className={'close-modal'} onClick={ closeModal }>
        <FontAwesomeIcon icon="times"  />
      </div>
      <div className={'branches-list'}>
        {
          branches.map(branch => (
            (!branch.parent_chain_guid_code || showAllBranch) && <Branch branchInfo={branch} openBranch={openBranch}/>
          ))
        }
      </div>
    </div>
  );
};

export default BranchesListModal;
